import { TherapistAction } from '../../../src/redux/actions/constant';

export const therapistPatientUnAssignAction = (payload: any) => {
  return {
    type: TherapistAction.THERAPIST_PATIENT_UNASSIGN_REQUEST,
    payload,
  };
};

export const therapistPatientUnAssignReset = () => {
  return {
    type: TherapistAction.THERAPIST_PATIENT_UNASSIGN_RESET,
  };
};
